<!-- <p>
  drzava-modal-update works!
</p> -->
<!-- <form (ngSubmit)="Save(f)" #f="ngForm" class="pl-2" (ngOnInit)="Save(f)"> -->
<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="DRZAVA.SINGULAR"></span></h2>
    <h1 class="modal-title">
      <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="DRZAVA.NEW"></span></span>
      <span *ngIf="baseUpdate.Item.ID > 0"><span>{{baseUpdate.Item.Naziv}}</span></span>
    </h1>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <yt-drzava-update #baseUpdate></yt-drzava-update>
</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()" [disabled]="saveDisabled"><span [innerHTML]="'FW.ACTION.SAVE.ACTION' | translate">Sačuvaj</span></button>
  <!-- <button type="submit" class="btn btn-primary"><span [innerHTML]="'ACTION.SAVE.ACTION' | translate"></span></button> -->
  <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
</div>
<!-- </form> -->